import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articleSlugs, articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="w-full bg-background-900 text-background-200 py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-background-50">
                Superbuy<span className="text-primary-400">Sheet</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              Your independent resource for organized product research, category guides, 
              and shopping strategies. Helping thousands of international shoppers make 
              smarter buying decisions every day.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><a href="#categories" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">Categories</a></li>
              <li><a href="#what-is" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">About Superbuy Sheet</a></li>
              <li><a href="#how-it-works" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">How It Works</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Top Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">SEO Guides</h4>
            <ul className="space-y-2.5">
              {articleSlugs.map((slug) => {
                const a = articles[slug];
                if (!a) return null;
                return (
                  <li key={slug}>
                    <Link to={`/article/${slug}`} className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                      {a.title.split(':')[0] || a.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">External Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Visit Main Platform <i className="ri-external-link-line ml-1 text-xs"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Superbuy Sheet <i className="ri-external-link-line ml-1 text-xs"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Buy It Now <i className="ri-external-link-line ml-1 text-xs"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} SuperbuySheet.cyou — Independent Research Platform. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            We are not affiliated with any shopping platform. This is an independent educational website.
          </p>
        </div>
      </div>
    </footer>
  );
}